import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import React from "react";
import "./index.css";

const ErrorView = () => {
  return (
    <div className="mb-3 mt-3 assetErrorView">
      <NoResultFoundSearch
        primaryMessage="Content error"
        secondaryMessage={"Something went wrong"}
      >
        <NoDataFoundIcon />
      </NoResultFoundSearch>
    </div>
  );
};

export default ErrorView;
